module.exports = "https://s91588.cdn.ngenix.net/home-frontend/_next/static/images/osago-mobile-83d2d70974a7c501e391740d103741db.png";